import React from 'react';

const IconButton = React.forwardRef(({
  label,
  children,
  className = '',
  variant = 'standard',
  type = 'button',
  ...props
}, ref) => (
  <button
    ref={ref}
    type={type}
    className={`sq-icon-button sq-icon-button--${variant} ${className}`.trim()}
    aria-label={label}
    {...props}
  >
    <span className="sq-icon-button__icon" aria-hidden="true">{children}</span>
  </button>
));

IconButton.displayName = 'IconButton';

export default IconButton;
